











import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import Selectqrcode from "../resources/selectqrcode.vue";
import Selectbarcode from "../resources/selectbarcode.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      Selectqrcode,
      Selectbarcode
  }
})
export default class SelectCodeBalloon extends Vue {
    select(type : string) {
        this.$emit("select", type);
        this.$emit("close");
    }

    close() {
        this.$emit("close");
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
